export default __webpack_public_path__ + "static/media/skovstykket-townhouse-4-rooms-03.cc9c5242.jpg";